export { StyledHeader, baseHeaderStyles } from "./StyledHeader";
export type { HeaderProps } from "./StyledHeader";
